module.exports = __webpack_public_path__ + "static/backlink-baa17e8367a40f4230b53b728feb9f08.png";